import { render, staticRenderFns } from "./LetterEdit.vue?vue&type=template&id=0a09ca8f&scoped=true"
import script from "./LetterEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./LetterEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LetterEdit.vue?vue&type=style&index=0&id=0a09ca8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a09ca8f",
  null
  
)

export default component.exports